<template>
  <div class="row">
    <div
      class="col-12 d-flex justify-content-center align-items-center row-controls order-lg-1 order-2"
    >
      <!-- Rótulo e "x / y" já no HTML do SSR (saem das props): se a linha só
           enchesse depois de montar, empurraria a foto (CLS no desktop) -->
      <div class="col-2 col-mobile">
        <span class="title" style="margin-left: 30px">{{ sessionLabel }}</span>
      </div>
      <div class="col-8 slide-controls">
        <div class="d-flex justify-content-center align-items-center">
          <div class="col-4 ps-2 angle-left">
            <font-awesome v-if="!loading && isMobile()"
              :icon="['fas', 'angle-left']"
              size="md"
              class="cursor-pointer color-icon"
              @click="clickPrev"
              @mouseover="hover = false"
              @mouseleave="hover = false"
            />
            <!--
            <font-awesome v-else
              :icon="['fas', 'minus']"
              size="md"
              class="cursor-pointer color-icon"
              @click="minusPlay()"
              @mouseover="hover = true"
              @mouseleave="hover = false"
            />
            -->
          </div>
          <!--
          <div class="col-4 text-center">
            <font-awesome
              v-if="!slidePlay"
              :icon="['fas', 'play']"
              size="md"
              class="cursor-pointer color-icon"
              @click="startPlay()"
              @mouseover="hover = true"
              @mouseleave="hover = false"
            />
            <font-awesome
              v-else
              :icon="['fas', 'pause']"
              size="md"
              class="cursor-pointer color-icon"
              @click="stopPlay()"
              @mouseover="hover = true"
              @mouseleave="hover = false"
            />
          </div>
          -->
          <div class="col-4 text-end pe-2 angle-right">
            <font-awesome v-if="!loading && isMobile()"
              :icon="['fas', 'angle-right']"
              size="md"
              class="cursor-pointer color-icon"
              @click="clickNext"
              @mouseover="hover = false"
              @mouseleave="hover = false"
            />
            <!--
            <font-awesome v-else
              :icon="['fas', 'plus']"
              size="md"
              class="cursor-pointer color-icon"
              @click="plusPlay()"
              @mouseover="hover = true"
              @mouseleave="hover = false"
            />
            -->
          </div>
          <span
            class="color-icon size-seconds position-absolute"
            :style="
              !hover
                ? { display: 'none' }
                : { display: 'block', right: '-35px', top: '-2px' }
            "
            >{{ seconds }}s</span
          >
        </div>
      </div>
      <div v-if="!isOnLockedSlide" class="col-2 x-of-y col-mobile">
        <span class="title" style="margin-left: 50px"
          >{{ (props.offsetInPart ?? 0) + imageNumber }} / {{ props.totalInPart ?? totalSection }}
        </span>
      </div>
    </div>
    <div class="col-12 order-lg-2 order-1 super-zoom-carousel-wrapper">
      <Carousel
        ref="crslModel"
        :transition="1"
        v-bind="settings"
        v-model="currentSlideImg"
        @click="click"
        id="modelo"
        @slide-end="moveSlide"
      >
        <!-- <Slide :key="'prev'" v-if="prevEnable && imageNumber == 1">
          <div class="text-center mt-5 spin-load">
            <div class="spinner-border" role="status" v-if="!loadindSpinner">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </Slide> -->
        <Slide :key="'load'" v-if="loading">
          <!-- Antes de montar (e no HTML do SSR) a 1ª foto já aparece: é o
               elemento LCP do /photo -->
          <div v-if="imagesModel?.length" class="card">
            <img
              :src="`${imagesModel[0]}`"
              :alt="carouselAltText(0)"
              width="467"
              height="700"
              fetchpriority="high"
            />
          </div>
          <div v-else class="text-center mt-5 spin-load">
            <div class="spinner-border" role="status" v-if="!loadindSpinner">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </Slide>
        <Slide
          v-if="!loading && imagesModel.length"
          v-for="(img, i) in imagesModel"
          :key="i"
        >
          <div
            class="card"
            :class="{ 'super-zoom-frame': zoomActive && !isMobile() }"
            @mouseenter="onZoomMouseEnter"
            @mousemove="onZoomMouseMove"
            @mouseleave="onZoomMouseLeave"
          >
            <img
              :src="`${img}`"
              :alt="carouselAltText(i)"
              @dblclick="
                zoomEnable ? emits('showModalModelSlideShow', true) : emits('showModalPopupZoom', true)
              "
              width="467"
              height="700"
              :style="
                isZooming && zoomActive && !isMobile()
                  ? {
                      transform: `scale(${ZOOM_FACTOR})`,
                      transformOrigin: `${zoomX}% ${zoomY}%`,
                      transition: 'transform-origin 0.05s linear',
                    }
                  : {
                      transform: 'scale(1)',
                      transformOrigin: 'center center',
                      transition: 'transform 0.2s ease',
                    }
              "
            />
          </div>
        </Slide>
        <Slide :key="'locked'" v-if="showLockedSlide">
          <div class="card locked-preview-card" @click="onLockedSlideClick">
            <div class="locked-preview-blur-bg">
              <img
                :src="`${props.nextLockedThumb}`"
              />
            </div>
            <font-awesome class="locked-preview-lock-icon" :icon="['fas', 'lock']" size="2x" />
          </div>
        </Slide>
        <Slide :key="'next'" v-if="!showLockedSlide && nextEnable && totalSection == imageNumber">
          <div class="text-center mt-5 spin-load">
            <div class="spinner-border" role="status" v-if="!loadindSpinner">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation v-if="!loading" />
        </template>
      </Carousel>
      <div v-if="showSuperZoomTooltip" class="super-zoom-tooltip">
        <button
          type="button"
          class="super-zoom-tooltip-close"
          @click="closeSuperZoomTooltip"
          aria-label="Fechar"
        >
          <font-awesome :icon="['fas', 'xmark']" />
        </button>
        <div class="super-zoom-tooltip-text">
          {{ translate.superZoomTooltip }}
        </div>
      </div>
    </div>
    <div
      v-if="!isMobile() && !loading"
      class="col-12 order-lg-3 super-zoom-row d-none d-lg-flex justify-content-center align-items-center"
    >
      <label class="super-zoom-label">
        <input
          type="checkbox"
          class="super-zoom-input"
          v-model="superZoom"
          @click="onSuperZoomClick"
        />
        <span class="super-zoom-custom">
          <font-awesome
            v-if="superZoom"
            :icon="['fas', 'check']"
            class="super-zoom-check-icon"
          />
        </span>
        <span class="super-zoom-text">{{ translate.superZoomLabel }}</span>
      </label>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { isMobile } from "@/shared/utils/mobile";
import translateModel from "@/tradutors/model";

const props = defineProps([
  "imagesModel",
  "nameModel",
  "currentImage",
  "slidePlay",
  "seconds",
  "sessionLabel",
  "keyDownEvents",
  "loadindSpinner",
  "zoomEnable",
  "nextEnable",
  "prevEnable",
  "imageAltText",
  "nextLockedThumb",
  "nextBlocked",
  "offsetInPart",
  "totalInPart",
  "prevBlocked"
]);
const emits = defineEmits([
  "showModalSubscribePlans",
  "changeAutomatic",
  "updateSlidePlay",
  "updateCurrentImage",
  "updateSeconds",
  "showModalModelSlideShow",
  "updateImageView",
  "showModalPopupZoom",
]);

const loading = ref(true);
const loadingI = ref(true);
// O store de usuário vem do localStorage antes da hidratação, e o SSR é sempre
// anônimo: o que depende dele só entra no template depois de montar.
const montado = ref(false);
const imageNumber = ref(1);
const totalSection = computed(() => props.imagesModel.length);
const interval = ref<any>(null);
const currentSlideImg = ref(0);
const crslModel = ref<any>(null);

const carouselAltText = (index: number) => {
  const base = props.imageAltText ?? props.nameModel;
  return `${base} - ${props.sessionLabel} | Img ${index + 1}`;
};  
onMounted(() => {
  montado.value = true;
  if (props.imagesModel.length) {
    loading.value = false;
    loadingI.value = false;
    setTimeout(() => {
      crslModel.value.slideTo(props.currentImage);
    }, 300);
    window.addEventListener("keydown", handleKeydown);
  }
});

watch(
  () => props.imagesModel,
  (val) => {
    loading.value = true;
    if (val.length) {
      loading.value = false;
      //rolar tela até crslModel
      crslModel.value.$el.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        crslModel.value.slideTo(props.currentImage);              
        //remover atributo disabled do botão prev
        const btnPrev = document.querySelector(".carousel__prev") as HTMLElement;
        if (btnPrev) {
          btnPrev.removeAttribute("disabled");
          btnPrev.classList.remove("carousel__prev--disabled");
        }
      }, 300);
      if (props.currentImage == 0) {        
        currentSlideImg.value = -1;        
      }
    }
  }
);

onUnmounted(() => {
  clearInterval(interval.value);
  window.removeEventListener("keydown", handleKeydown);
});

const route = useRoute();

const settings = computed(() => {
  return {
    i18n: {
      iconArrowRight:
        route.params.language == "pt-br" ? "Próxima Imagem" : "Next Image",
      iconArrowLeft:
        route.params.language == "pt-br" ? "Imagem Anterior" : "Previous Image",
    },
  };
});

const translate = computed(() =>
  route.params.language === "pt-br"
    ? translateModel.portugues
    : translateModel.ingles
);

watch(
  () => props.slidePlay,
  (val) => {
    if (val == true) {
      startPlay();
    } else {
      clearInterval(interval.value);
    }
  }
);
watch(
  () => imageNumber.value,
  (val) => {
    emits("updateImageView", val);
  }
);

watch(
  () => props.currentImage,
  (val) => {
    currentSlideImg.value = val;    
    imageNumber.value = val + 1;
    setTimeout(() => {
      crslModel.value.slideTo(val);
    }, 1);
    if (val == 0) {
      //remover atributo disabled do botão prev
      const btnPrev = document.querySelector(".carousel__prev") as HTMLElement;
      if (btnPrev) {
        btnPrev.removeAttribute("disabled");
        btnPrev.classList.remove("carousel__prev--disabled");
      }
      currentSlideImg.value = -1;
    }
  }
);

watch(
  () => props.keyDownEvents,
  (val) => {
    if (import.meta.client)
      if (val) {
        window.addEventListener("keydown", handleKeydown);
      } else {
        window.removeEventListener("keydown", handleKeydown);
      }
  }
);
const hover = ref(false);
const prevSession = ref(false);
const storeUser = userStore();

const superZoom = ref(false);
const showSuperZoomTooltip = ref(false);
const zoomActive = ref(false);
const isZooming = ref(false);
const zoomX = ref(50);
const zoomY = ref(50);
const ZOOM_FACTOR = 2.0;

function onSuperZoomClick(e: Event) {
  if (!props.zoomEnable) {
    e.preventDefault();
    emits("showModalPopupZoom", true);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "paywall",
      paywall: { acionador: "Ao clicar no checkbox SuperZoom" },
    });
  }
}

watch(superZoom, (val) => {
  if (val) {
    showSuperZoomTooltip.value = true;
    zoomActive.value = false;
  } else {
    showSuperZoomTooltip.value = false;
    zoomActive.value = false;
    isZooming.value = false;
  }
});

function closeSuperZoomTooltip() {
  showSuperZoomTooltip.value = false;
  zoomActive.value = true;
}

function onZoomMouseEnter() {
  if (!zoomActive.value || isMobile()) return;
  isZooming.value = true;
}

function onZoomMouseMove(e: MouseEvent) {
  if (!zoomActive.value || isMobile()) return;
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
  zoomX.value = ((e.clientX - rect.left) / rect.width) * 100;
  zoomY.value = ((e.clientY - rect.top) / rect.height) * 100;
}

function onZoomMouseLeave() {
  isZooming.value = false;
}

watch(currentSlideImg, () => {
  isZooming.value = false;
  zoomX.value = 50;
  zoomY.value = 50;
});

const showLockedSlide = computed(() => {
  return (
    montado.value &&
    !storeUser.isActiveUser &&
    props.nextLockedThumb &&
    props.nextEnable
  );
});

const isNextBlocked = computed(() => {
  return !storeUser.isActiveUser && props.nextBlocked && props.nextEnable;
});

const isPrevBlocked = computed(() => {
  return !storeUser.isActiveUser && props.prevBlocked && props.prevEnable;
});

const isOnLockedSlide = computed(
  () => showLockedSlide.value && currentSlideImg.value >= props.imagesModel.length
);

function onLockedSlideClick() {
  emits("showModalSubscribePlans", true);
  emits("updateSlidePlay", false);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "paywall",
    paywall: { acionador: "Ao clicar na prévia bloqueada do carrossel" },
  });
}

function click(eventChange: any) {
  //Avançar
  if (
    currentSlideImg.value === props.imagesModel.length &&
    eventChange.target.closest("button.carousel__next") != null
  ) {
    if (props.nextEnable && !isNextBlocked.value) {
      emits("changeAutomatic", true);
    } else if (!storeUser.isActiveUser) {
      emits("updateSlidePlay", false);
      if (!showLockedSlide.value) {
        emits("showModalSubscribePlans", true);
      }
    } else {
      emits("changeAutomatic", true);
    }
  }
  //Voltar
  if (
    currentSlideImg.value == -1 &&
    eventChange.target.closest("button.carousel__prev") != null
  ) {
    if (isPrevBlocked.value) {
      // Seção anterior bloqueada — não navegar
    } else if (props.prevEnable) {
      emits("changeAutomatic", false);
    } else if (!storeUser.isActiveUser) {
      emits("updateSlidePlay", false);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "paywall",
        paywall: {
          acionador:
            "Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada",
        },
      });
    }
  }
}
function moveSlide(data: any) {
  imageNumber.value = Math.min(data.currentSlideIndex + 1, totalSection.value);
  emits("updateCurrentImage", data.currentSlideIndex);
  if (isNextBlocked.value && data.currentSlideIndex >= totalSection.value) {
    emits("updateSlidePlay", false);
    if (!showLockedSlide.value) {
      emits("showModalSubscribePlans", true);
    }
  }
  if (
    data.currentSlideIndex + 1 > totalSection.value &&
    storeUser.isActiveUser &&
    !prevSession.value &&
    !props.slidePlay &&
    isMobile()
  ) {
    prevSession.value = true;
    const btnPrev = document.querySelector(".carousel__next") as HTMLElement;
    if (btnPrev) {
      btnPrev.removeAttribute("disabled");
      btnPrev.classList.remove("carousel__next--disabled");
      btnPrev.click();
    }
  } else {
    prevSession.value = false;
  }
  if (data.currentSlideIndex === 0 && storeUser.isActiveUser && !isPrevBlocked.value && isMobile()) {
    prevSession.value = true;
    if (props.imagesModel[0] && props.imagesModel[0].indexOf("api.belladasemana") == -1) {
      setTimeout(() => {
        (document.querySelector(".carousel__prev") as HTMLElement)?.click();
      }, 2500);
    }
  }
}
function startPlay() {
  clearInterval(interval.value);
  emits("updateSlidePlay", true);
  interval.value = setInterval(function () {
    const carrossel: HTMLCollectionOf<HTMLElement> =
      document.getElementsByClassName(
        "carousel__next"
      ) as HTMLCollectionOf<HTMLElement>;
    if (carrossel.length) {
      carrossel[0].click();
    }
  }, props.seconds * 1000);
}
function stopPlay() {
  emits("updateSlidePlay", false);
}
async function minusPlay() {
  if (props.seconds > 1) {
    await emits("updateSeconds", props.seconds - 1);
    startPlay();
  }
}
async function plusPlay() {
  if (props.seconds < 10) {
    await emits("updateSeconds", props.seconds + 1);
    startPlay();
  }
}
function startStopPlay() {
  if (props.slidePlay) {
    stopPlay();
  } else {
    startPlay();
  }
}
function handleKeydown(e: any) {
  if (e.keyCode == 37) {
    //Arrow Left
    if (document.getElementsByClassName("carousel__prev").length) {
      (
        document.getElementsByClassName("carousel__prev")[0] as HTMLElement
      ).click();
    }
  } else if (e.keyCode == 39) {
    //Arrow Right
    if (document.getElementsByClassName("carousel__next").length) {
      (
        document.getElementsByClassName("carousel__next")[0] as HTMLElement
      ).click();
    }
  }
  /*
  else if (e.keyCode == 38) {
    //Arrow Up
    e.preventDefault();
    plusPlay();
    hover.value = true;
    setTimeout(() => {
      hover.value = false;
    }, 2000);
  } else if (e.keyCode == 40) {
    //Arrow Down
    e.preventDefault();
    minusPlay();
    hover.value = true;
    setTimeout(() => {
      hover.value = false;
    }, 2000);
  } else if (e.keyCode == 13 || e.keyCode == 32) {
    //Enter or Space
    e.preventDefault();
    startStopPlay();
    hover.value = true;
    setTimeout(() => {
      hover.value = false;
    }, 2000);
  }
  */
}

function clickNext(eventChange: any) {
  if (
    currentSlideImg.value + 1 === props.imagesModel.length &&
    eventChange.target.closest("div.angle-right") != null
  ) {
    if (props.nextEnable && !isNextBlocked.value) {
      emits("changeAutomatic", true);
      return false;
    }
    if (!storeUser.isActiveUser) {
      emits("updateSlidePlay", false);
      if (!showLockedSlide.value) {
        emits("showModalSubscribePlans", true);
        return false;
      }
    } else {
      emits("changeAutomatic", true);
      return false;
    }
  }
  if (
    showLockedSlide.value &&
    currentSlideImg.value >= props.imagesModel.length &&
    eventChange.target.closest("div.angle-right") != null
  ) {
    return false;
  }
  emits("updateCurrentImage", props.currentImage + 1);
}
function clickPrev(eventChange: any) {
  if (
    (currentSlideImg.value == 0 || currentSlideImg.value == -1) &&
    eventChange.target.closest("div.angle-left") != null
  ) {
    if (isPrevBlocked.value) {
      return false;
    }
    if (props.prevEnable) {
      emits("changeAutomatic", false);
    } else if (!storeUser.isActiveUser) {
      emits("updateSlidePlay", false);
    }
    return false;
  }
  emits("updateCurrentImage", props.currentImage - 1);
}
</script>
<style scoped>
.button--more svg {
  color: #b20000;
}

.button--more {
  font-family: "Exo-2";
  font-weight: bold;
  color: #898989;
  font-size: 16px;
}

.small svg {
  margin-right: 5px;
}

.card img {
  width: 100%;
  object-fit: cover;
  height: auto;
}

.card {
  background-color: #fff;
}

.spin-load {
  width: 100%;
  min-height: 31rem;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  color: #b20000;
}

.x-of-y {
  font-size: 18px;
}

.slide-controls {
  width: 170px;
}

.color-icon {
  color: #5b5858;
  font-size: 16px;
}

.size-seconds {
  font-size: 14px;
  color: white;
  background-color: #5b5858;
  border-radius: 50%;
  width: 27px;
  height: 27px;
  padding: 3px 6px;
}

.title {
  font-family: "Roboto-Regular";
  font-size: 16px;
}

.row-controls {
  margin-bottom: 20px;
}

.locked-preview-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  min-height: 31rem;
}

.locked-preview-blur-bg {
  position: absolute;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(6px);
  left: 50%;
  transform: translate(-50%, 0%);  
}

.locked-preview-lock-icon {
  position: relative;
  z-index: 1;
  color: #b20000;
  font-size: 3rem;
}

.locked-preview-blur-bg img {
  width: 500px !important;
}

.super-zoom-carousel-wrapper {
  position: relative;
}

.super-zoom-frame {
  overflow: hidden;
  cursor: zoom-in;
}

.super-zoom-frame img {
  will-change: transform, transform-origin;
}

.super-zoom-label {
  position: absolute;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  margin: 0;
  left: 160px;
  top: 8px;
}

.super-zoom-input {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  opacity: 0;
  margin: 0;
  cursor: pointer;
  z-index: 1;
}

.super-zoom-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #868686;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  transition: background 0.15s;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.super-zoom-input:checked + .super-zoom-custom {
  background: #868686;
}

.super-zoom-check-icon {
  color: #fff;
  font-size: 12px;
  line-height: 1;
}

.super-zoom-text {
  font-family: "Exo-2";
  font-weight: 600;
  color: #868686;
  font-size: 16px;
}

.super-zoom-tooltip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 50;
  background: rgba(255, 255, 255, 0.75);
  padding: 28px 40px;
  max-width: 420px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.super-zoom-tooltip-text {
  color: #000;
  font-family: "Exo-2";
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 16px;
  width: 225px;
}

.super-zoom-tooltip-ok {
  background: #868686;
  color: #fff;
  padding: 8px 28px;
  border: none;
  border-radius: 20px;
  font-family: "Exo-2";
  font-weight: 700;
  cursor: pointer;
}

.super-zoom-tooltip-close {
  position: absolute;
  top: 6px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #5b5858;
  line-height: 1;
}

/* regras mobile 992px */
@media screen and (max-width: 992px) {
  .x-of-y {
    position: absolute;
    left: -15px;
    top: 12px;
  }
  .col-mobile {
    display: none;
  }

  .slide-controls {
    position: absolute;
    z-index: 1;
    margin-top: 139px;
  }

  .row-controls {
    margin-top: unset;
    margin-bottom: unset;
  }
  .locked-preview-blur-bg img {  
    width: 95vw !important;
  }
}
</style>
